/* Miss Color - welkomspopup */
(function () {
  function init() {
    var root = document.querySelector('[data-mc-welkomspopup]');
    if (!root) return;

    var wrapper = root.parentNode;
    if (wrapper !== document.body) document.body.appendChild(root);

    var overlay = root.querySelector('.mc-wp__overlay');
    var modal = root.querySelector('.mc-wp__modal');
    var form = root.querySelector('.mc-wp__form');
    var email = root.querySelector('.mc-wp__email');
    var errorEl = root.querySelector('[data-mc-error]');
    var submitBtn = root.querySelector('[data-mc-submit]');
    var tabWrap = root.querySelector('.mc-wp__tab-wrap');
    var bar = root.querySelector('.mc-wp__bar');
    var d = root.dataset;

    var cfg = {
      trigger: d.trigger || 'delay',
      delay: parseInt(d.delay, 10) || 5,
      scroll: parseInt(d.scroll, 10) || 50,
      freq: d.freq === 'days' ? 'days' : 'session',
      days: parseInt(d.days, 10) || 14,
      mode: d.mode || 'direct',
      tab: d.tab === 'true',
      bar: d.bar === 'true'
    };

    var design = !!(window.Shopify && window.Shopify.designMode);
    var force = /[?&]mcwelkom=1/.test(window.location.search);
    var K = { sub: 'mc_wp_subscribed', state: 'mc_wp_state', dismissed: 'mc_wp_dismissed', tab: 'mc_wp_tab_hidden', bar: 'mc_wp_bar_hidden' };
    var S = { dismissed: 'mc_wp_s_dismissed', tab: 'mc_wp_s_tab_hidden', bar: 'mc_wp_s_bar_hidden', pending: 'mc_wp_pending' };
    var lastFocus = null;
    var armed = false;
    var ticking = false;

    function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    function del(k) { try { localStorage.removeItem(k); } catch (e) {} }
    function sesGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function sesSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
    function sesDel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }

    /* Wegklikken geldt standaard alleen voor de huidige sessie: bij een volgend
       bezoek verschijnt de popup weer. Staat de instelling op dagen, dan bewaren
       we het tijdstip juist wel langdurig. */
    if (cfg.freq === 'session') {
      del(K.dismissed);
      del(K.tab);
      del(K.bar);
    }

    function markDismissed() {
      if (cfg.freq === 'days') set(K.dismissed, String(Date.now()));
      else sesSet(S.dismissed, '1');
    }

    function isDismissed() {
      if (cfg.freq === 'days') {
        var dis = parseInt(get(K.dismissed), 10);
        return !!(dis && Date.now() - dis < cfg.days * 86400000);
      }
      return sesGet(S.dismissed) === '1';
    }

    function isTabHidden() { return sesGet(S.tab) === '1' || get(K.tab) === '1'; }
    function isBarHidden() { return sesGet(S.bar) === '1' || get(K.bar) === '1'; }

    /* De zijwidget hoort verticaal gecentreerd in het scherm te staan. Als een
       bovenliggend element het referentiekader van position:fixed verschuift,
       klopt top:50% niet meer. We meten daarom waar hij echt staat en corrigeren. */
    function positionTab() {
      if (!tabWrap || tabWrap.hidden) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      tabWrap.style.top = '50%';
      var rect = tabWrap.getBoundingClientRect();
      if (!rect.height) return;
      var target = Math.max(8, (vh - rect.height) / 2);
      var delta = target - rect.top;
      if (Math.abs(delta) > 1) {
        tabWrap.style.top = 'calc(50% + ' + Math.round(delta) + 'px)';
      }
    }

    function schedulePosition() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        positionTab();
      });
    }

    function state() {
      var s = get(K.state);
      return s === 'success' || s === 'pending' ? s : 'start';
    }

    function setState(name) {
      var states = root.querySelectorAll('.mc-wp__state');
      for (var i = 0; i < states.length; i++) states[i].hidden = states[i].getAttribute('data-state') !== name;
      set(K.state, name);
    }

    function focusables() {
      return Array.prototype.filter.call(
        modal.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea'),
        function (el) { return el.offsetParent !== null; }
      );
    }

    function focusModal() {
      window.setTimeout(function () { try { modal.focus({ preventScroll: true }); } catch (e) { try { modal.focus(); } catch (e2) {} } }, 40);
    }

    function onKey(e) {
      if (e.key === 'Escape' || e.keyCode === 27) { close(); return; }
      if (e.key !== 'Tab' && e.keyCode !== 9) return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (document.activeElement === modal) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      if (!overlay.hidden) return;
      setState(state());
      lastFocus = document.activeElement;
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      focusModal();
    }

    function close(remember) {
      if (overlay.hidden) return;
      overlay.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (remember !== false) markDismissed();
      showTab();
      showBar();
      if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
    }

    function showTab() {
      if (!tabWrap || !cfg.tab || isTabHidden()) return;
      tabWrap.hidden = false;
      positionTab();
      window.setTimeout(positionTab, 300);
    }

    function showBar() { if (bar && cfg.bar && !isBarHidden() && state() === 'success') bar.hidden = false; }

    function showError(msg) { if (!errorEl) return; errorEl.textContent = msg; errorEl.classList.add('is-visible'); }
    function hideError() { if (!errorEl) return; errorEl.textContent = ''; errorEl.classList.remove('is-visible'); }

    function success() {
      set(K.sub, '1');
      setState(cfg.mode === 'confirm' ? 'pending' : 'success');
      hideError();
      showBar();
      focusModal();
    }

    function legacyCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
    }

    function flashCopied() {
      var c = root.querySelector('[data-mc-copied]');
      if (!c) return;
      c.classList.add('is-visible');
      window.setTimeout(function () { c.classList.remove('is-visible'); }, 2000);
    }

    function doCopy() {
      var codeEl = root.querySelector('[data-mc-code]');
      var code = codeEl ? codeEl.textContent.replace(/\s+/g, '') : '';
      if (!code) return;
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(flashCopied, function () { legacyCopy(code); flashCopied(); });
      } else {
        legacyCopy(code);
        flashCopied();
      }
    }

    function vacationVisible() {
      var v = document.getElementById('vacation-popup');
      return !!(v && v.offsetParent !== null);
    }

    function maybeAutoOpen() {
      if (design) return;
      if (get(K.sub) === '1') return;
      if (vacationVisible()) return;
      if (isDismissed()) return;
      open();
    }

    function arm() {
      if (armed) return;
      armed = true;
      if (cfg.trigger === 'scroll') {
        var onScroll = function () {
          var h = document.documentElement.scrollHeight - window.innerHeight;
          var p = h > 0 ? (window.pageYOffset / h) * 100 : 100;
          if (p >= cfg.scroll) { window.removeEventListener('scroll', onScroll); maybeAutoOpen(); }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      } else if (cfg.trigger === 'exit') {
        var onLeave = function (e) {
          if (e.clientY <= 0) { document.removeEventListener('mouseout', onLeave); maybeAutoOpen(); }
        };
        document.addEventListener('mouseout', onLeave);
        window.setTimeout(maybeAutoOpen, 25000);
      } else {
        window.setTimeout(maybeAutoOpen, cfg.delay * 1000);
      }
    }

    window.addEventListener('resize', schedulePosition, { passive: true });
    window.addEventListener('orientationchange', function () { window.setTimeout(positionTab, 250); });
    window.addEventListener('scroll', schedulePosition, { passive: true });
    window.addEventListener('load', positionTab);

    var closers = root.querySelectorAll('[data-mc-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', function () { close(); });

    var openers = root.querySelectorAll('[data-mc-open]');
    for (var j = 0; j < openers.length; j++) openers[j].addEventListener('click', function () { open(); });

    var copiers = root.querySelectorAll('[data-mc-copy]');
    for (var k = 0; k < copiers.length; k++) copiers[k].addEventListener('click', doCopy);

    if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

    var tabDismiss = root.querySelector('[data-mc-tab-dismiss]');
    if (tabDismiss) tabDismiss.addEventListener('click', function (e) {
      e.stopPropagation();
      if (tabWrap) tabWrap.hidden = true;
      sesSet(S.tab, '1');
    });

    var barClose = root.querySelector('[data-mc-bar-close]');
    if (barClose) barClose.addEventListener('click', function () {
      if (bar) bar.hidden = true;
      sesSet(S.bar, '1');
    });

    if (form) {
      /* Shopify's spamcontrole (hCaptcha) hangt aan een normale formulierverzending.
         Daarom versturen we niet via fetch: we onthouden de status en tonen de
         successtatus zodra de pagina terugkomt met customer_posted=true. */
      form.setAttribute('action', (form.getAttribute('action') || '/contact').split('#')[0]);

      form.addEventListener('submit', function (e) {
        var value = (email && email.value ? email.value : '').trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) {
          e.preventDefault();
          showError(root.getAttribute('data-msg-invalid') || 'Vul een geldig e-mailadres in.');
          if (email) email.focus();
          return;
        }
        hideError();
        sesSet(S.pending, '1');
        window.setTimeout(function () {
          if (submitBtn) submitBtn.disabled = true;
        }, 0);
      });
    }

    if (design) {
      document.addEventListener('shopify:section:select', function (e) { if (e.target === wrapper) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target === wrapper) close(false); });
      showTab();
    }

    var posted = /[?&]customer_posted=true/.test(window.location.search);
    var recovered = posted && sesGet(S.pending) === '1';
    if (recovered) sesDel(S.pending);

    if (recovered) {
      if (window.history && window.history.replaceState) {
        try {
          var clean = window.location.pathname + window.location.search.replace(/[?&]customer_posted=true/, '').replace(/^&/, '?');
          window.history.replaceState({}, '', clean);
        } catch (e) {}
      }
      success();
      open();
    } else {
      setState(state());
      if (get(K.sub) === '1' || isDismissed()) showTab();
      showBar();
      if (force) open(); else arm();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
